export default __webpack_public_path__ + "static/eden-reforestation-projects-v2-19e69a96279ef1082699a1df6daefefe.jpg";